import React, { useState } from 'react';
import G from './Getters';
import { useStore } from 'react-redux';
import MergedImages from './MergedImages';
import pivotAxes, { computePermutation } from './pivotAxes';
import SortableLetters from './SortableLetters';
import CropWrapper from './CropWrapper';

function ImageRow({ row, rowIndex, colors }) {
  const store = useStore();
  const state = store.getState();
  let urls = row.map(imageId => G.getImageRecordUrl(state, { imageId }));
  let imgparams = row.map((imageId,i) => {
    return {
      imgurl: urls[i],
      brightness: 1,
      contrast: 1,
      colorProjection: colors[i]
    }
  });
  if (row.length > 1) {
    return <div
      key={rowIndex}
      style={{ display: 'flex', flexDirection: 'row', gap: '0.5rem' }}
    >
      {row.map((imageId, colIndex) => (
        <CropWrapper imageId={imageId} />
      ))}
      {/* <MergedImages toDraw={imgparams} width={128} height={128} /> */ }
    </div>;
  } else {
    return <div
      key={rowIndex}
      style={{ display: 'flex', flexDirection: 'row', gap: '0.5rem' }}
    >
      {row.map((imageId, colIndex) => (
        <CropWrapper imageId={imageId} />
      ))}
    </div>;
  }
}

const colorChoices = ['red', 'green', 'blue', 'magenta', 'yellow', 'grey'];


const ColorDropdownRow = ({ colors, setColors }) => {
  const handleChange = (index, newColor) => {
    const updatedColors = [...colors];
    updatedColors[index] = newColor;
    setColors(updatedColors);
  };

  return (
    <div style={{ display: "flex", gap: "1rem" }}>
      {colors.map((color, index) => (
        <select
          style={{width: 128}}
          key={index}
          value={color}
          onChange={(e) => handleChange(index, e.target.value)}
        >
          {colorChoices.map((c) => (
            <option key={c} value={c}>
              {c}
            </option>
          ))}
        </select>
      ))}
    </div>
  );
};

const ImageGridViewer = ({ imageArray: imageArrayProp, order: orderProp, permOrder, setPermOrder }) => {
  console.log('order', orderProp, permOrder, imageArrayProp);
  let perm = permOrder && computePermutation(orderProp, permOrder).slice(0, permOrder.length);
  let imageArray; 
  let order = permOrder ?? orderProp;
  if (Array.isArray(imageArrayProp)) {
    imageArray = perm != null ? pivotAxes(imageArrayProp, perm) : imageArrayProp;
  } else {
    // Pretend it's 1-dimensional
    imageArray = [imageArrayProp];
    order = ['U'];
  }
  const shape = getArrayShape(imageArray);

  if (shape.length === 0) {
    throw new Error("unhandled");
    // 0D array: Single image
    return (
      <div style={{ padding: '1rem' }}>
        <img
          src={imageArray}
          alt="single"
          style={imgStyle}
        />
      </div>
    );
  }

  const numSliders = Math.max(0, shape.length - 2);
  const [indices, setIndices] = useState(Array(numSliders).fill(0));
  
  if (numSliders != indices.length) {
    setIndices(Array(numSliders).fill(0));
  }

  const handleSliderChange = (dim, value) => {
    const newIndices = [...indices];
    newIndices[dim] = parseInt(value);
    setIndices(newIndices);
  };

  const selected = getNestedArray(imageArray, indices);
  console.log(selected);
  const remainingShape = shape.slice(numSliders);

  //console.log(remainingShape, selected);

  const imageRows = (() => {
    if (remainingShape.length === 2) {
      return selected;
    } else if (remainingShape.length === 1) {
      return [selected];
    } else {
      return [[selected]];
    }
  })();

  //console.log(indices);

  const [colors, setColors] = useState(imageRows[0].map(x => 'grey'));
  if (imageRows[0].length !== colors.length) {
    setColors(imageRows[0].map(x => 'grey'));
  }

  function setColor(i, col) {
    setColors(a => a.map((b,j) => j == i ? col : b));
  }

  return (
    <div>
      {setPermOrder != null && (
        <div style={{display:'flex',flexDirection: 'row', alignItems: 'center'}}>
          <span> Pivot axes: </span>
          <SortableLetters letters={order} onUpdate={newOrder => {
            setPermOrder(newOrder);
          }} />
        </div>
      )}
      <div style={{ padding: '1rem' }}>
        {numSliders > 0 && (
          <div style={{ marginBottom: '1rem' }}>
            {indices.map((val, i) => (
              shape[i] > 1 && <div key={i} style={{ marginBottom: '0.5rem' }}>
                <label>
                  Dimension {order[i]} (0 to {shape[i] - 1}): {val}
                  <input
                    type="range"
                    min="0"
                    max={shape[i] - 1}
                    value={val}
                    onChange={(e) => handleSliderChange(i, e.target.value)}
                    style={{ width: '100%' }}
                  />
                </label>
              </div>
            ))}
          </div>
        )}
        <ColorDropdownRow colors={colors} setColors={setColors} />
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
          {imageRows.map((row, rowIndex) => (
            <ImageRow row={row} rowIndex={rowIndex} colors={colors} />
          ))}
        </div>
      </div>
    </div>
  );
};

// Image styling (inline, no Tailwind)
const imgStyle = {
  width: '128px',
  height: '128px',
  objectFit: 'contain',
  border: '1px solid #ccc',
  borderRadius: '6px',
};

// Get shape of a nested array
function getArrayShape(arr) {
  const shape = [];
  let temp = arr;
  while (Array.isArray(temp)) {
    shape.push(temp.length);
    temp = temp[0];
  }
  return shape;
}

// Access nested array by a list of indices
function getNestedArray(arr, indices) {
  let result = arr;
  for (let idx of indices) {
    result = result[idx];
  }
  return result;
}

export default ImageGridViewer;
